import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {SliderComponent, SliderModule, SliderTickEventArgs, SliderTooltipEventArgs, TicksDataModel, TooltipDataModel} from "@syncfusion/ej2-angular-inputs";
import {FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RadioButtonModule} from "@syncfusion/ej2-angular-buttons";


@Component({
    selector: 'app-form-slider',
    imports: [
        SliderModule,
        FormsModule,
        ReactiveFormsModule,
        RadioButtonModule
    ],
    templateUrl: './form-slider.component.html',
    styleUrl: './form-slider.component.scss'
})
export class FormSliderComponent implements OnInit, OnChanges {
  @ViewChild('slider') public slider: SliderComponent | undefined;

  @Input() public fCN: string = '';
  @Input() public fG: FormGroup = new FormGroup({});
  @Input() public min: number = 0;
  @Input() public max: number = 10;
  @Input() public step: number = 1;
  @Input() public largeStepMarker: number = 1;
  @Input() public smallStepMarker: number = 1;
  @Input() public showSmallTicks: boolean = true;
  @Input() public unit: string = '€';
  @Input() public unitPositionLeft: boolean = false;
  @Input() public showTooltip: boolean = true;
  @Input() public disabled: boolean = false;
  @Input() public type: string = 'MinRange' as const;
  @Input() public errorText: string = '';
  @Input() public hasErrorField: boolean = false;

  public ticks: TicksDataModel = {placement: 'After', largeStep: this.largeStepMarker, smallStep: this.smallStepMarker, showSmallTicks: this.showSmallTicks};
  public tooltip: TooltipDataModel = {placement: 'Before', isVisible: this.showTooltip};

  public ngOnInit(): void {
    setTimeout(() => {
      this.slider?.refresh()
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.ticks = {placement: 'After', largeStep: this.largeStepMarker, smallStep: this.smallStepMarker, showSmallTicks: this.showSmallTicks};
    this.tooltip = {placement: 'Before', isVisible: this.showTooltip};
    this.slider?.refresh();
    if (changes['disabled'] && this.fG.controls[this.fCN]) {
      if (this.disabled) {
        this.fG.controls[this.fCN].disable();
      } else {
        this.fG.controls[this.fCN].enable();
      }
    }
  }

  public tooltipChange(args: SliderTooltipEventArgs | SliderTickEventArgs): void {
    if (!this.unit) return;
    if (this.unitPositionLeft) {
      args.text = this.unit + ' ' + parseFloat(args.value.toString());
    } else {
      args.text = parseFloat(args.value.toString()) + this.unit;
    }
  }
}
